export default __webpack_public_path__ + "static/media/vehicle_driver.c198ef9a.svg";